import type { AdapterMeta } from "@repo/adapter-core";

export const REALMARK_META: AdapterMeta = {
  slug: "realmark",
  name: "Realmark",
  baseUrl: "https://www.realmark.com.au",
  description: "Perth and WA specialist agency for residential sold property listings.",
  supportedStates: ["WA"],
  urlPattern: /realmark\.com\.au\/listing\/[a-z0-9-]+/i,
  sourceType: "agency",
};
